/**
 * message redux constants
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// redux action IDs
export const SHOW_MESSAGE                   = 'SHOW_MESSAGE';
export const CLEAR_MESSAGE                  = 'CLEAR_MESSAGE';
export const SHOW_DIALOG_MESSAGE            = 'SHOW_DIALOG_MESSAGE';
export const CLEAR_DIALOG_MESSAGE           = 'CLEAR_DIALOG_MESSAGE';
